module.exports = __webpack_public_path__ + "img/buddy.82a0d89e.png";